import { WlTransactionStatus } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export { WlTransactionStatus };

export const wlTransactionStatusDictionary = createSimpleDictionary([
    { id: WlTransactionStatus.NotProcessed, name: 'dictionaries.wlTransactionStatus.notProcessed' },
    { id: WlTransactionStatus.Processed, name: 'dictionaries.wlTransactionStatus.processed' },
    { id: WlTransactionStatus.Failed, name: 'dictionaries.wlTransactionStatus.failed' },
    { id: WlTransactionStatus.ManualClosed, name: 'dictionaries.wlTransactionStatus.manualClosed' },
]);
